(function () {
  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorInSearch(color, search) {
    const c = normalize(color);
    if (!c) return false;

    const words = c.split(' ').filter(Boolean);
    if (!words.length) return false;

    return words.some((word) => search.includes(word));
  }

  function filterByColor(root, color) {
    const enabled = root.dataset.autoMatchColor === 'true';
    if (!enabled) return;

    const cards = Array.from(root.querySelectorAll('[data-bcc-pair-card]'));
    if (!cards.length) return;

    const normalizedColor = normalize(color || '');
    if (!normalizedColor) {
      cards.forEach((card) => card.classList.remove('is-hidden'));
      return;
    }

    let matches = 0;
    cards.forEach((card) => {
      const search = normalize(card.dataset.search || '');
      const matched = colorInSearch(normalizedColor, search);
      card.classList.toggle('is-hidden', !matched);
      if (matched) matches += 1;
    });

    // Never leave section empty: if no color-specific matches, show all patches.
    if (matches === 0) {
      cards.forEach((card) => card.classList.remove('is-hidden'));
    }
  }

  async function addPatchToCart(button) {
    const variantId = Number(button.dataset.variantId || 0);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'ADDING...';

    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const addRes = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!addRes.ok) {
        throw new Error('Add to cart failed');
      }

      const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'becco-patches-pair',
            data: {
              source: 'becco-patches-pair',
              itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
            },
          },
        })
      );

      if (window.BeccoCart) {
        await window.BeccoCart.notifyAdd({
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          sourceId: 'becco-patches-pair',
          itemCount: 1,
        });
      }
    } catch (error) {
      button.textContent = 'TRY AGAIN';
      window.setTimeout(function () {
        button.textContent = originalText;
      }, 1200);
      button.disabled = false;
      button.classList.remove('is-loading');
      return;
    }

    button.textContent = 'ADDED';
    window.setTimeout(function () {
      button.textContent = originalText;
      button.disabled = false;
      button.classList.remove('is-loading');
    }, 1000);
  }

  function initPairSection(root) {
    const buttons = Array.from(root.querySelectorAll('[data-bcc-pair-add]'));

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        addPatchToCart(button);
      });
    });

    const initialColor = root.dataset.baseColor || '';
    filterByColor(root, initialColor);

    document.addEventListener('bcc:variant-change', function (event) {
      const detail = event && event.detail ? event.detail : {};
      filterByColor(root, detail.color || '');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bcc-pair-root]').forEach(initPairSection);
  });
})();
